import { Order, OrderType } from '../order/types'
import { QuoteRequest, RfqEntryModel } from './types'

export const fetchRFQs = (showAll: boolean) =>
  ({
    type: `rfq.fetchRFQs`,
    payload: { showAll }
  } as const)
export type FetchRFQsAction = ReturnType<typeof fetchRFQs>

export const fetchRFQsSuccess = (quoteRequests: QuoteRequest[]) =>
  ({
    type: `rfq.fetchRFQsSuccess`,
    payload: { quoteRequests }
  } as const)
export type FetchRFQsSuccessAction = ReturnType<typeof fetchRFQsSuccess>

export const fetchRFQActivitySuccess = (quoteRequests: QuoteRequest[]) =>
  ({
    type: `rfq.fetchRFQActivitySuccess`,
    payload: { quoteRequests }
  } as const)
export type FetchRFQActivitySuccessAction = ReturnType<
  typeof fetchRFQActivitySuccess
>

export const fetchRFQUnsubscribe = () =>
  ({
    type: `rfq.fetchRFQUnsubscribe`
  } as const)
export type fetchRFQUnsubscribeAction = ReturnType<typeof fetchRFQUnsubscribe>

export const submitRfq = (
  order: Order,
  rfq: RfqEntryModel,
  transactionId: number,
  custId: number
) =>
  ({
    type: `rfq.submitRfq`,
    payload: {
      order,
      rfq,
      transactionId,
      custId
    } as const
  } as const)
export type SubmitRfqAction = ReturnType<typeof submitRfq>

export const submitRFQFailure = (
  securityId: number,
  transactionId: number,
  type: OrderType,
  error: { message?: string }
) =>
  ({
    type: `rfq.submitRFQFailure`,
    error: true,
    payload: {
      securityId,
      transactionId,
      type,
      error
    } as const
  } as const)
export type SubmitRFQFailureAction = ReturnType<typeof submitRFQFailure>

export const cancelRfq = (securityId: number) =>
  ({
    type: `rfq.cancelRfq`,
    payload: { securityId }
  } as const)
export type CancelRfqAction = ReturnType<typeof cancelRfq>

export const cancelRfqSuccess = (securityId: number) =>
  ({
    type: `rfq.cancelRfqSuccess`,
    payload: { securityId }
  } as const)
export type CancelRfqSuccessAction = ReturnType<typeof cancelRfqSuccess>

export const cancelRfqFailure = (
  securityId: number,
  type: OrderType,
  error: Error
) =>
  ({
    type: `rfq.cancelRfqFailure`,
    payload: { securityId, type, error }
  } as const)
export type CancelRfqFailureAction = ReturnType<typeof cancelRfqFailure>

export const acceptRfqQuote = (
  securityId: number,
  requestId: number,
  quoteId: number
) =>
  ({
    type: `rfq.acceptRfqQuote`,
    payload: { securityId, requestId, quoteId }
  } as const)
export type AcceptRfqQuoteAction = ReturnType<typeof acceptRfqQuote>

export const acceptRfqQuoteSuccess = (securityId: number, quoteId: number) =>
  ({
    type: `rfq.acceptRfqQuoteSuccess`,
    payload: { securityId, quoteId }
  } as const)
export type AcceptRfqQuoteSuccessAction = ReturnType<
  typeof acceptRfqQuoteSuccess
>

export const acceptRfqQuoteFailure = (
  securityId: number,
  type: OrderType,
  message: string
) =>
  ({
    type: `rfq.acceptRfqQuoteFailure`,
    payload: { securityId, type, message }
  } as const)
export type AcceptRfqQuoteFailureAction = ReturnType<
  typeof acceptRfqQuoteFailure
>

export const rejectRfqQuote = (requestId: number, securityId: number) =>
  ({
    type: `rfq.rejectRfqQuote`,
    payload: { securityId, requestId }
  } as const)
export type RejectRfqQuoteAction = ReturnType<typeof rejectRfqQuote>

export const rejectRfqQuoteSuccess = (securityId: number, quoteId: number) =>
  ({
    type: `rfq.rejectRfqQuoteSuccess`,
    payload: { securityId, quoteId }
  } as const)
export type RejectRfqQuoteSuccessAction = ReturnType<
  typeof rejectRfqQuoteSuccess
>

export const rejectRfqQuoteFailure = (
  securityId: number,
  type: OrderType,
  message: string
) =>
  ({
    type: `rfq.rejectRfqQuoteFailure`,
    payload: { securityId, type, message }
  } as const)
export type RejectRfqQuoteFailureAction = ReturnType<
  typeof rejectRfqQuoteFailure
>

export const dismissRfqError = (securityId: number, type: OrderType) =>
  ({
    type: `rfq.dismissRfqError`,
    payload: { securityId, type }
  } as const)
export type DismissRfqErrorAction = ReturnType<typeof dismissRfqError>

export type RFQActions =
  | AcceptRfqQuoteAction
  | AcceptRfqQuoteSuccessAction
  | AcceptRfqQuoteFailureAction
  | CancelRfqAction
  | CancelRfqSuccessAction
  | CancelRfqFailureAction
  | DismissRfqErrorAction
  | FetchRFQsAction
  | fetchRFQUnsubscribeAction
  | FetchRFQsSuccessAction
  | FetchRFQActivitySuccessAction
  | RejectRfqQuoteAction
  | RejectRfqQuoteSuccessAction
  | RejectRfqQuoteFailureAction
  | SubmitRfqAction
  | SubmitRFQFailureAction
